import axios from 'axios';
import opportunityStatusesService from '@/services/opportunity-statuses.service';

const initialState = () => ({
  opportunityStatuses: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getOpportunityStatuses({ commit }) {
    commit('GET_OPPORTUNITY_STATUSES');
    return opportunityStatusesService.getOpportunityStatuses().then(
      (opportunityStatuses) => commit('GET_OPPORTUNITY_STATUSES_SUCCESS', opportunityStatuses),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('GET_OPPORTUNITY_STATUSES_ERROR', error);
        }
      },
    );
  },
  editOpportunityStatus({ commit }, { opportunityStatusId, opportunityStatus }) {
    commit('EDIT_OPPORTUNITY_STATUS');
    return opportunityStatusesService.editOpportunityStatus({ opportunityStatusId, opportunityStatus }).then(
      (editedOpportunityStatus) => commit('EDIT_OPPORTUNITY_STATUS_SUCCESS', editedOpportunityStatus),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('EDIT_OPPORTUNITY_STATUS_ERROR', error);
        }
      },
    );
  },
  addOpportunityStatus({ commit }, opportunityStatus) {
    commit('CREATE_OPPORTUNITY_STATUS');
    return opportunityStatusesService.addOpportunityStatus(opportunityStatus).then(
      (createdOpportunityStatus) => commit('CREATE_OPPORTUNITY_STATUS_SUCCESS', createdOpportunityStatus),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('CREATE_OPPORTUNITY_STATUS_ERROR', error);
        }
      },
    );
  },
  deleteOpportunityStatus({ commit }, opportunityStatusId) {
    commit('DELETE_OPPORTUNITY_STATUS');
    return opportunityStatusesService.deleteOpportunityStatus(opportunityStatusId).then(
      (deletedOpportunityStatus) => commit('DELETE_OPPORTUNITY_STATUS_SUCCESS', deletedOpportunityStatus),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('DELETE_OPPORTUNITY_STATUS_ERROR', error);
        }
      },
    );
  },
  RESET(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const mutations = {
  // The list stays shown until the new one replaces it.
  GET_OPPORTUNITY_STATUSES(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  GET_OPPORTUNITY_STATUSES_SUCCESS(state, opportunityStatuses) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.opportunityStatuses = opportunityStatuses;
  },
  GET_OPPORTUNITY_STATUSES_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  EDIT_OPPORTUNITY_STATUS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  EDIT_OPPORTUNITY_STATUS_SUCCESS(state, opportunityStatus) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.opportunityStatuses = state.opportunityStatuses.map((status) => {
      if (status.id === opportunityStatus.id) {
        return opportunityStatus;
      }
      return status;
    });
  },
  EDIT_OPPORTUNITY_STATUS_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  CREATE_OPPORTUNITY_STATUS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  CREATE_OPPORTUNITY_STATUS_SUCCESS(state, opportunityStatus) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.opportunityStatuses.unshift(opportunityStatus);
  },
  CREATE_OPPORTUNITY_STATUS_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  DELETE_OPPORTUNITY_STATUS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  DELETE_OPPORTUNITY_STATUS_SUCCESS(state, opportunityStatusId) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.opportunityStatuses = state.opportunityStatuses.filter((status) => status.id !== opportunityStatusId);
  },
  DELETE_OPPORTUNITY_STATUS_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
};

const getters = {
  opportunityStatuses: (state) => state.opportunityStatuses,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const opportunityStatuses = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
